import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "max-w-[500px] w-full mx-auto py-16" }
const _hoisted_2 = { class: "bg-primary-400 rounded-lg px-6 py-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl mb-6 font-bold" }, "Search Patient", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-sm font-bold mb-6" }, "Patient Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Add Filter Search", -1)

import { ref, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { PlusIcon, MinusIcon } from "@heroicons/vue/24/outline";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { errorResponse } from "@/helpers/errorMessage";
import { useRouter } from "vue-router";  
import { useNetworkStore } from "@/store/network";
import PatientRecordService from "@/classes/Patients/PatientRecordService";
import Rules from "@/classes/Patients/Offline/Validation/Rules";
import useVuelidate from "@vuelidate/core";
import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
import Storage from "@/helpers/storage";
import { onIonViewWillEnter } from "@ionic/vue";
import { useSecurityFeature } from "@/store/securityFeature";
 

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchForm',
  setup(__props) {

const router = useRouter();
const form = ref<{ last_name: string; first_name: string; birthdate: any }>({
	last_name: "",
	first_name: "",
	birthdate: "",
});
const addFilter = ref<boolean>(false);
const errors = ref<object>({});
const loading = ref<boolean>(false);
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const { searchRules } = Rules;
const storage = new Storage();
const resetKey = ref(0);

/**
 * Validate the form using Vuelidator
 */
 const validateForm = async () =>{
	const vuelidate = useVuelidate(searchRules({...form.value}), form.value)
	const result = await vuelidate.value.$validate();

    if (result) {
        return null;
    } else {
        errors.value = ErrorValidation.getErrors(vuelidate.value);
        errorResponse(errors.value);
        return errors.value;
    }
}

const submit = async (): void => {
	loading.value = true;

    // Set validation rule for Online and Offline
    const validate = await validateForm();
    if (validate) {
        return;
    }
    
    // Call this service when network is online or offline
    const response = await PatientRecordService.search({
			last_name: form.value.last_name,
			first_name: form.value.first_name,
			birthdate: form.value.birthdate,
		}, isNetworkAvailable.value);

    if (response?.status === 200 || response?.data != undefined) {
        errors.value = null;
        
        loading.value = false;
        latestSearchHistory();
        router.push({ path: "/patient/index", query: form.value });
    } else {
        const error = response;
        loading.value = false;
        errors.value = errorResponse(error.response?.data?.errors);
    }
};

const latestSearchHistory = () => {
    storage.set('search', JSON.stringify({
        last_name: form.value.last_name,
        first_name: form.value.first_name,
        birthdate: form.value.birthdate,
    }));
}

const checkHasPasswordBlocker = () => {
    const item = sessionStorage.getItem('hasPasswordBlocker');
    if (!item) {
        useSecurityFeature().isActivated = false
        useSecurityFeature().isPasswordBlocker = true;
        sessionStorage.setItem('hasPasswordBlocker', true);
    }
}

const resetForm = () => {
    form.value.first_name = "";
    form.value.last_name = "";
    form.value.birthdate = "";
    resetKey.value++;
}

onIonViewWillEnter(() => {
    resetForm();
    if (!isNetworkAvailable.value) {
        checkHasPasswordBlocker();
    }
});

return (_ctx: any,_cache: any) => {
  const _component_page_loader = _resolveComponent("page-loader")!

  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("form", {
            class: "flex flex-col space-y-6",
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createVNode(TextInput, {
              type: "text",
              label: "First Name",
              placeholder: "First name",
              name: "first_name",
              id: "first_name",
              modelValue: form.value.first_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
              error: errors.value?.first_name
            }, null, 8, ["modelValue", "error"]),
            _createVNode(TextInput, {
              type: "text",
              label: "Last Name",
              placeholder: "Last name",
              name: "last_name",
              id: "last_name",
              modelValue: form.value.last_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
              error: errors.value?.last_name
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_unref(Disclosure), null, {
              default: _withCtx(({ open }) => [
                _createVNode(_unref(DisclosureButton), { class: "text-left cursor-default w-full md:pt-0 pt-3" }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonComponent, {
                      customClass: "secondary w-full",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (addFilter.value = true))
                    }, {
                      default: _withCtx(() => [
                        (!open)
                          ? (_openBlock(), _createBlock(_unref(PlusIcon), {
                              key: 0,
                              class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon"
                            }))
                          : _createCommentVNode("", true),
                        open
                          ? (_openBlock(), _createBlock(_unref(MinusIcon), {
                              key: 1,
                              class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon"
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(DisclosurePanel), null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(DatePicker, {
                      key: resetKey.value,
                      id: "birthdate",
                      name: "birthdate",
                      label: "Birthdate",
                      modelValue: form.value.birthdate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.birthdate) = $event)),
                      error: errors.value?.birthdate
                    }, null, 8, ["modelValue", "error"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(ButtonComponent, {
                type: "submit",
                size: "large",
                btnWidth: "w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Search ")
                ]),
                _: 1
              })
            ])
          ], 32)
        ])
      ]),
      _createVNode(_component_page_loader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})